<p class="title">Comentarios</p>
<div class="grid">
  <div class="grid-comments">
    <mat-divider></mat-divider>
    <mat-nav-list>
      <mat-list-item *ngFor="let comment of sectionsComments">
        <div class="grid-container">
          <div class="grid-item">
            <span class="section">En {{ comment.handoverSectionName }} <span class="username">{{ comment.userName }}</span> comenta:</span></div>
          <div class="grid-item">
            <textarea disabled = true rows = 5 class = "comment">{{ comment.comment }}</textarea>
          </div>
          <div class="grid-item-date">
            <span class="date">{{ comment.date }}</span>
          </div>
          <div class="grid-item-actions">
            <button mat-icon-button class="button button-edit" (click)="edit(comment)" [disabled]="readOnlyContent || hasLocationHandover(comment.handoverSectionId)">
              <mat-icon class="material-icons-outlined">edit_outline</mat-icon>
              <span> Editar</span>
            </button>
            <button mat-icon-button class="button button-delete" (click)="delete(comment)" [disabled]="readOnlyContent || hasLocationHandover(comment.handoverSectionId)">
              <mat-icon class="material-icons-outlined">delete_outline</mat-icon>
              <span> Eliminar</span>
            </button>
          </div>
        </div>
        <mat-divider></mat-divider>
      </mat-list-item>
    </mat-nav-list>
  </div>
</div>
<div class="grid-container-ac warning-modified-comment" *ngIf="!readOnlyContent && showUpdateWarning">
  <div class="grid-item-ac1">
    <h3>Otro usuario modificó este comentario</h3>
    <p>Si desea conservar sus cambios cópielos antes de presionar el botón Actualizar.</p>
    <div class="grid-item-ac1 actions">
      <button mat-button (click)="updateComment()" class="purple-button">Actualizar</button>
    </div>
  </div>
</div>
<div class="grid-container-ac">
  <div class="grid-item-ac1">
    <label class="label-commment">Comentar en</label>
    <mat-form-field class = "mat-form-field-lightblue-color">
      <mat-label>[Seleccionar]</mat-label>
      <mat-select class="wider" name="section" [(ngModel)]="handoverSectionId" [disabled]="readOnlyContent || isEditingExistingComment">
        <mat-option>[Seleccionar]</mat-option>
        <mat-option *ngFor="let section of sections" [value]="section.handoverSectionId"
            [disabled]="section.commented || hasLocationHandover(section.handoverSectionId)">
          <div class="grid-option" [ngClass]="{'grid-option-disabled': section.commented}">
            <div class="grid-option-item-1">
              <span [ngClass]="{'text-option-commented': !section.commented, 'text-option-commented-disabled': section.commented}">{{ section.handoverSectionName }}</span>
            </div>
            <div class="grid-option-item-2">
              <span class="label-option-commented-disabled" *ngIf="section.commented">{{isEditingExistingComment ? '' : 'Ya comentaste esta sección'}}</span>
            </div>
          </div>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="grid-item-ac2">
    <mat-form-field class = "mat-form-field-lightblue-color">
      <mat-label>Escribí un comentario</mat-label>
      <textarea matInput #commentEdit maxlength="1500" [(ngModel)]="comment" rows="5" [disabled]="readOnlyContent"></textarea>
    </mat-form-field>
  </div>
  <div class="grid-item-ac2 edit-actions">
    <button mat-button class="discard" (click)="discardEdition()" *ngIf="!readOnlyContent && isEditingExistingComment">DESCARTAR</button>
    <button mat-button class="ready" (click)="saveSectionComment()" [disabled]="readOnlyContent">LISTO</button>
  </div>
</div>
